export default __webpack_public_path__ + "static/media/num-icon5.897f34be.svg";